import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRANCH_UPDATE_RESOURCE = "branch" as const;
export const BRANCH_UPDATE_API_PATH = `/v1/${BRANCH_UPDATE_RESOURCE}/{uuid}` as const;

export type BranchUpdateBody =
  paths[typeof BRANCH_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type BranchUpdateResponse =
  paths[typeof BRANCH_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useBranchUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BranchUpdateResponse, Error, BranchUpdateBody & { uuid: string }>({
    mutationFn: async (application: BranchUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = application;
      const response = await alphartisApiAxios.patch<BranchUpdateResponse>(
        `/v1/${BRANCH_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRANCH_UPDATE_RESOURCE, "search"],
      });
    },
  });
};
